import { Component } from '@angular/core';

@Component({
  selector: 'app-search-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './search-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class SearchIconComponent {}
